import { API_ENDPOINT } from "@iso/config/index";
import { axiosClient } from "@iso/helpers/axios.config";

const COMMON_ENDPONT = `${API_ENDPOINT}/common`;

const commonManagerApi = {
   clearCacheKMS: (langCode) => {
      return axiosClient.post(`${COMMON_ENDPONT}/clear-cache/${langCode}`);
   },
};

export default commonManagerApi;
